import theme from "theme/theme";

export const unAssigned = {
  isTeam: false,
  name: "Unassigned",
  avatarColor: theme.palette.background.paper,
}